/** Full-page state for a signed-in user whose workspaces could not be shown. */

import { useTranslation } from "react-i18next";
import { useAuth } from "../lib/AuthContext";

interface WorkspaceProblemProps {
  /** true: removed from their workspace (nothing to retry); false: the load failed */
  noAccess: boolean;
  onRetry: () => void;
}

export function WorkspaceProblem({ noAccess, onRetry }: WorkspaceProblemProps) {
  const { t } = useTranslation();
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 px-4 text-center">
      <h1 className="text-lg font-semibold text-foreground">
        {noAccess ? t("workspaceLoad.noAccess.title") : t("workspaceLoad.errorTitle")}
      </h1>
      <p className="text-sm text-muted-foreground max-w-md">
        {noAccess ? t("workspaceLoad.noAccess.message") : t("workspaceLoad.error")}
      </p>
      <div className="flex gap-3">
        {!noAccess && (
          <button onClick={onRetry} className="px-4 py-2 text-sm font-medium bg-blue-600 text-white rounded hover:bg-blue-700">
            {t("workspaceLoad.retry")}
          </button>
        )}
        <button
          onClick={() => signOut().catch((err) => console.error("Sign out failed", (err as { code?: string }).code))}
          className="px-4 py-2 text-sm font-medium border border-border rounded hover:bg-accent"
        >
          {t("workspaceLoad.signOut")}
        </button>
      </div>
    </div>
  );
}
